import { useMemo } from 'react';

import { mapExportItemToDetails } from '@/features/DataHub/api/pastExports.api';
import { usePastExports } from '@/features/DataHub/queries/hooks/usePastExports';

type UsePastExportDetailsOptions = {
  enabled?: boolean;
};

export const usePastExportDetails = (exportId: string, options?: UsePastExportDetailsOptions) => {
  const { data: exports, isLoading, isError } = usePastExports();

  const data = useMemo(() => {
    if (!exports || !(options?.enabled ?? true)) return undefined;
    const item = exports.find(e => e.id === exportId);
    if (!item) return undefined;
    return mapExportItemToDetails(item);
  }, [exports, exportId, options?.enabled]);

  return {
    data,
    isLoading: isLoading && (options?.enabled ?? true),
    isError
  };
};
